import axios from "axios";
import { APIRequest, baseURL } from "../core";

export const getCsrfToken: APIRequest<string> = async () => {
  const { data } = await axios.get(`${baseURL}/csrf-token`);

  return data;
};
